import * as React from 'react';

export interface LinearProgressBarProps {
  error?: boolean;
  errorMessage?: string;
  light?: boolean;
  showProgressIndication?: boolean;
  value?: number | string;
  skin?: 'standard' | 'success' | 'warning' | 'premium' | 'neutral';
  dataHook?: string;
  padding?: 'none';
}

export default class LinearProgressBar extends React.PureComponent<LinearProgressBarProps> {}
